"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CylindricalToRectangular = CylindricalToRectangular;
exports.add = add;
exports.degToRad = degToRad;
exports.getRelativeCenter = getRelativeCenter;
exports.getRelativeRotation = getRelativeRotation;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function degToRad(angle) {
  return angle / 180 * Math.PI;
}
function CylindricalToRectangular(radius, deg, origin) {
  var rad = degToRad(deg);
  return {
    x: origin.x + Math.round(radius * Math.cos(rad)),
    y: origin.y + Math.round(radius * Math.sin(rad))
  };
}
function add(o1, o2) {
  // 1+1
  if (typeof o1 === "number" && typeof o2 === "number") {
    return o1 + o2;
  }

  // array[idx] + array[idx]
  if (Array.isArray(o1) && Array.isArray(o2)) {
    if (o1.length !== o2.length) {
      throw new Error("Arrays must have the same length");
    }
    return o1.map(function (value, index) {
      return value + o2[index];
    });
  }

  // object[key] + array[key]
  if (_typeof(o1) === "object" && _typeof(o2) === "object") {
    var result = {};
    Object.keys(o1).forEach(function (key) {
      if (o2.hasOwnProperty(key)) {
        result[key] = add(o1[key], o2[key]);
      } else {
        result[key] = o1[key];
      }
    });
    return result;
  }
  throw new Error("Unsupported types for addition");
}
function getRelativeCenter(shape) {
  var _ref = shape || {},
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height;
  var centerX = width / 2;
  var centerY = height / 2;
  return {
    x: centerX,
    y: centerY
  };
}
function getRelativeRotation(t0, tf) {
  // return the offset rotation to move from initial to final angle
  // Note: (pos) + 90 --> counterclockwise direction

  // find offset
  var dt = (360 + (tf - t0)) % 360;

  // find minimum offset on unit circle
  return dt;
}